/* tslint:disable */
/* eslint-disable */
/**
 * Public Track API
 * Public Track APIs provide customers access to their SPiDRs, Security Focuses and SPiDR Blueprints
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ConciergeTierFromJSON, ConciergeTierToJSON, } from './ConciergeTier';
/**
 * Check if a given object implements the Blueprint interface.
 */
export function instanceOfBlueprint(value) {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "subscriptions" in value;
    isInstance = isInstance && "technicalDomains" in value;
    isInstance = isInstance && "primaryTechnicalDomain" in value;
    isInstance = isInstance && "technologies" in value;
    isInstance = isInstance && "nist" in value;
    isInstance = isInstance && "nist2" in value;
    isInstance = isInstance && "cis" in value;
    isInstance = isInstance && "vendorIDs" in value;
    isInstance = isInstance && "doesExpire" in value;
    isInstance = isInstance && "tier" in value;
    return isInstance;
}
export function BlueprintFromJSON(json) {
    return BlueprintFromJSONTyped(json, false);
}
export function BlueprintFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'id': json['id'],
        'type': json['type'],
        'subscriptions': json['subscriptions'],
        'technicalDomains': json['technicalDomains'],
        'primaryTechnicalDomain': json['primaryTechnicalDomain'],
        'technologies': json['technologies'],
        'nist': json['nist'],
        'nist2': json['nist2'],
        'cis': json['cis'],
        'vendorIDs': json['vendorIDs'],
        'doesExpire': json['doesExpire'],
        'tier': ConciergeTierFromJSON(json['tier']),
    };
}
export function BlueprintToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'id': value.id,
        'type': value.type,
        'subscriptions': value.subscriptions,
        'technicalDomains': value.technicalDomains,
        'primaryTechnicalDomain': value.primaryTechnicalDomain,
        'technologies': value.technologies,
        'nist': value.nist,
        'nist2': value.nist2,
        'cis': value.cis,
        'vendorIDs': value.vendorIDs,
        'doesExpire': value.doesExpire,
        'tier': ConciergeTierToJSON(value.tier),
    };
}
